import {salesDeadline} from './salesDeadlineLabel';
export function SalesDeadline({value, timeZone}: {value?: string; timeZone?: string}) {
  const deadline = salesDeadline(value, timeZone);
  return <small className={`op-sales-deadline ${deadline.overdue ? 'op-stock-shortage' : 'pb-muted'}`}>{deadline.text}</small>;
}
